module.exports = __webpack_public_path__ + "img/slide11-piece-26.311a0bdd.png";